import Axios from "axios";

export default {


    obtenerTurnadoColisiones(vm) {
        return vm.axios.post(`${vm.domain.domainNameForApi}Dashboard/ObtenerTurnadoColisiones`).then(response => response.data)

    },
    obtenerTurnadoRobos(vm) {
        return vm.axios.post(`${vm.domain.domainNameForApi}Dashboard/ObtenerTurnadoRobos`).then(response => response.data)

    },
    obtenerPendientesColisiones(vm) {
        return vm.axios.post(`${vm.domain.domainNameForApi}Dashboard/ObtenerPendientesColisiones`).then(response => response.data)
    },
    obtenerPendientesRobos(vm) {
        return vm.axios.post(`${vm.domain.domainNameForApi}Dashboard/ObtenerPendientesRobos`).then(response => response.data)
    },
    obtenerVhDetenidos(vm) {
        return vm.axios.post(`${vm.domain.domainNameForApi}Dashboard/ObtenerVhDetenidos`).then(response => response.data)
    },
    obtenerAseguradoras(vm) {
        vm.axios.post(`${vm.domain.domainNameForApi}Dashboard/ObtenerAseguradora`).then(response => {
            vm.aseguradoras = response.data;
            vm.aseguradora = { clclave: vm.aseguradoras[0].clclave, clnombre: vm.aseguradoras[0].clnombre };
        })
    },
    obtenergfFlotillas(vm) {
        var valor;
        //console.log('valida si tiene asignado grupo');
        vm.axios.post(`${vm.domain.domainNameForApi}Dashboard/ValidargfFlotillasAsignadas`).then(response1 => {
            // console.log(response1.data);
            valor = response1.data;
            if (valor == 0) {
                vm.valid = false;
                vm.gfactive = false;

            }
            else {
                vm.axios.post(`${vm.domain.domainNameForApi}Dashboard/ObtenergfFlotillas`).then(response2 => {
                    if (response2.data.length > 0) {
                        response2.data.forEach(item => item.gfnombre = item.gfnombre.normalize("NFD").replace(/[\u0300-\u036f]/g, ""));
                    }
                    vm.gfflotillas = response2.data;
                    vm.axios.post(`${vm.domain.domainNameForApi}Dashboard/ObtenergfFlotillasAsignadas`).then(response3 => {

                        vm.valid = true;
                        vm.gfactive = true;
                        vm.gfflotilla = response3.data;


                    });

                });
            }
        });


    },
    obtenerFlotillas(vm) {
        vm.axios.post(`${vm.domain.domainNameForApi}Dashboard/ObtenerFlotilla`).then(response => {
            if (response.data.length > 0) {
                response.data.forEach(item => item.flnomcorto = item.flnomcorto.normalize("NFD").replace(/[\u0300-\u036f]/g, ""));
            }
            vm.flotillas = response.data;
            vm.flotillasTemp = [...vm.flotillas];

            vm.axios.post(`${vm.domain.domainNameForApi}Dashboard/ObtenergfSeleccionadas`).then(response2 => {
                vm.busqueda.flotilla = response2.data;
                //console.log('prueba de flotillaaass');
                //console.log(response2);
            })
        })
    },
    obtenerFlotillasLimpiar(vm) {
        vm.axios.post(`${vm.domain.domainNameForApi}Dashboard/ObtenerFlotillaLimpiar`).then(response => {
            //console.log('flotillaaass 2222222', response.data);
            if (response.data.length > 0) {
                response.data.forEach(item => item.flnomcorto = item.flnomcorto.normalize("NFD").replace(/[\u0300-\u036f]/g, ""));
            }
            vm.flotillas = response.data;
            vm.flotillasTemp = [...vm.flotillas];

        })
    },
    obtenerFlotillasporCliente(vm) {
        //console.log('flotillaaass por cliente');
        //console.log(vm.gfflotilla);
        var formData = new FormData();
        formData.append("gfflotilla", JSON.stringify(vm.gfflotilla));
        vm.axios.post(`${vm.domain.domainNameForApi}Dashboard/ObtenerFlotillaporCliente`, formData).then(response => {
            if (response.data.length > 0) {
                response.data.forEach(item => item.flnomcorto = item.flnomcorto.normalize("NFD").replace(/[\u0300-\u036f]/g, ""));
            }
            vm.flotillas = response.data;
            vm.flotillasTemp = [...vm.flotillas];
            vm.busqueda.flotilla = '';
        })
    },

    guardarFiltro(vm, flotillasF, gfflotilla, valida) {
        var formData = new FormData();
        formData.append("flotillas", JSON.stringify(flotillasF));
        formData.append("gfflotilla", JSON.stringify(gfflotilla));
        formData.append("valida", valida);
        return vm.axios.post(`${vm.domain.domainNameForApi}Dashboard/guardarFiltro`, formData).then(response => response.data)

    },


}